import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconUsers from 'components/icons/IconUsers';

const styles = theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    position: 'relative',
    zIndex: 10,
    backgroundColor: theme.palette.common.white,
  },
  grid: {
    minHeight: 330,
  },
  iconUsers: {
    width: 110,
    height: 94,
  },
});

const ScheduleCalendarNoDrivers = ({ classes }) => (
  <div className={classes.root}>
    <Grid
      className={classes.grid}
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <IconUsers className={classes.iconUsers} />
      </Grid>
      <Grid item>
        <Typography variant="subheading" color="secondary">
          Unfortunately, there are no drivers
        </Typography>
      </Grid>
    </Grid>
  </div>
);

ScheduleCalendarNoDrivers.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    iconUsers: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ScheduleCalendarNoDrivers);



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleCalendar/ScheduleCalendarNoDrivers.js